import type AiModelFilterView from '@UI/Pages/Administration/AiEngines/Sections/ModelsSection/Filters/AiModelFilterView';
import type AiModelView from '@UI/Store/AiConfiguration/Views/AiModelView';

/** Pure client-side filter: provider (exact) ∩ search (label or identifier). */
const filterAiModels = (models: readonly AiModelView[], filters: AiModelFilterView): AiModelView[] => {
	const normalizedSearch = filters.search.trim().toLowerCase();

	return models.filter((model) => {
		if (filters.providerId !== null && model.providerId !== filters.providerId) {
			return false;
		}

		if (
			normalizedSearch.length > 0 &&
			!model.label.toLowerCase().includes(normalizedSearch) &&
			!model.identifier.toLowerCase().includes(normalizedSearch)
		) {
			return false;
		}

		return true;
	});
};

export default filterAiModels;
